import { useState } from 'react'
import { Box, Button, Divider, Typography } from '@mui/material'

import { MUI, SolicitationContactModal } from 'components'

import { mixpanel } from 'helpers'

import { theme } from 'theme'
import upgradeImage from 'images/upgrade_to_dponet.svg'

const DPOnetCard = () => {
  const [openModal, setOpenModal] = useState(false)

  const handleOpenModal = () => {
    mixpanel('Home', 'Atualizar para dponet', {
      action: 'atualizar_para_dponet-home',
    })
    setOpenModal(true)
  }

  const handleCloseModal = () => setOpenModal(false)

  return (
    <Box display="flex" flexDirection="column" height="100%">
      <Box
        bgcolor={theme.palette.primary.main}
        borderRadius="5px 5px 0px 0px"
        display="flex"
        justifyContent="center"
        alignItems="center"
        px={4}
        py="15px"
      >
        <Typography color="white" variant="h5">
          DPOnet
        </Typography>
      </Box>
      <Divider />
      <Box
        bgcolor={theme.palette.primary.main}
        borderRadius="0px 0px 5px 5px"
        textAlign="justify"
        color="white"
        height="100%"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        p={4}
        gap={8}
      >
        <Box>
          <MUI.Typography variant="h6" gutterBottom $lgOnly={{ fontSize: 18 }}>
            Garanta sua conformidade!
          </MUI.Typography>
          <Typography variant="body2">
            Como usuário da DPO Easy, você está aproveitando a versão gratuita
            para dar os primeiros passos em direção à adequação. Faça o upgrade
            para a DPOnet e tenha acesso à plataforma completa, que te
            possibilitará alcançar a conformidade.
          </Typography>
        </Box>
        <Box display="flex" justifyContent="center">
          <img src={upgradeImage} width="50%" />
        </Box>
        <Button
          variant="contained"
          color="tertiary"
          fullWidth
          onClick={handleOpenModal}
        >
          Entrar em contato
        </Button>
      </Box>
      {openModal && (
        <SolicitationContactModal open={openModal} onClose={handleCloseModal} />
      )}
    </Box>
  )
}

export default DPOnetCard
